import React from 'react'

import { makeStyles } from '@material-ui/core/styles'

import IconTitle from './IconTitle'

import resourceInfo from 'shared/src/resource/info'

const useStyles = makeStyles(theme => ({

}))

const ResourceIconTitle = ({
  resource,
  className,
  textClassname,
  onClick,
}) => {
  const title = resourceInfo.title(resource)

  return (
    <IconTitle
      type={ resource.type }
      title={ title }
      className={ className }
      textClassname={ textClassname }
      onClick={ onClick }
    />
  )
}

ResourceIconTitle.defaultProps = {
  
}

export default ResourceIconTitle

